<template>
  <div class="agreement_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <div>用户协议与隐私政策</div>
    </div>
    <div class="agreement-content">
      <h1>
        <strong><b>用户协议与隐私政策</b></strong>
      </h1>
      <p>
        本协议（简称
        &ldquo;协议&rdquo;）是您与我们之间关于使用我们提供的服务所订立的协议。请您仔细阅读本协议的各项条款，在确认充分理解并同意后使用我们的服务。若您不同意本协议的任何条款，请勿使用我们的服务。
      </p>
      <h2>
        <strong><b>一、服务内容</b></strong>
      </h2>
      <p>我们提供的服务包括但不限于以下方面：</p>
      <ol>
        <li><span></span>通过我们的平台，您可以访问和使用我们提供的各类信息、资源、工具等；</li>
        <li><span></span>您可以在我们的平台上进行账户注册、发布信息、交流互动等；</li>
        <li><span></span>我们可能会根据用户需求及业务发展提供其他商业化服务或增值服务。</li>
      </ol>
      <h2>
        <strong><b>二、用户权利和义务</b></strong>
      </h2>
      <h3>
        <strong><b>（一）用户权利</b></strong>
      </h3>
      <ol>
        <li><span></span>依法自由注册、使用我们的服务；</li>
        <li><span></span>获得我们提供的符合服务标准的服务及合理的技术支持；</li>
        <li><span></span>对于我们的服务提出真实、合理的意见和建议；</li>
        <li><span></span>依法享有其他与我们提供的服务相关的合法权益。</li>
      </ol>
      <h3>
        <strong><b>（二）用户义务</b></strong>
      </h3>
      <ol>
        <li>
          <b><span></span></b><strong><b>信息真实准确</b></strong
          >：提供真实、准确、完整且最新的个人信息。若个人信息发生变更，应及时在平台内进行更新，以确保我们能够基于准确信息为您提供服务。例如，若您注册时预留的手机号码更换，应及时修改，避免因信息错误导致接收不到重要通知或影响服务使用。
        </li>
        <li>
          <b><span></span></b><strong><b>账户安全维护</b></strong
          >：妥善保管您的账号和密码。不向任何第三方透露账号及密码信息，避免使用过于简单易被猜测的密码（如连续数字、生日等）。定期更换密码以增强账户安全性。对在该账号下发生的所有行为，包括但不限于发布内容、操作交易等，您需承担全部责任。例如，若因您向他人透露密码导致账号被盗用进行了违规操作，您需承担相应后果。
        </li>
        <li>
          <b><span></span></b><strong><b>合法使用服务</b></strong
          >：不得利用我们的服务从事任何违法活动，包括但不限于侵犯他人知识产权、传播淫秽色情信息、进行诈骗活动、发布虚假广告等违反法律法规及社会公序良俗的行为。
        </li>
        <li>
          <b><span></span></b><strong><b>遵守相关规定</b></strong
          >：严格遵守所有与我们的服务相关的现行有效的法律法规和政策规定，包括但不限于互联网信息服务管理办法、网络安全法等。同时，遵守我们根据业务需求制定的关于服务使用的具体规则，如平台的内容发布规范、社区准则等。
        </li>
      </ol>
      <h2>
        <strong><b>三、隐私政策</b></strong>
      </h2>
      <h3>
        <strong><b>（一）个人信息的收集和使用</b></strong>
      </h3>
      <ol>
        <li>
          <b><span></span></b><strong><b>收集目的</b></strong
          >：我们收集和使用您的个人信息，主要目的是为您提供更好的服务体验，包括但不限于识别您的身份以提供个性化服务、处理您的交易请求、保障服务安全及改进服务质量等。例如，为您推荐符合您兴趣偏好的内容、完成您在平台上的购物订单等。
        </li>
        <li>
          <b><span></span></b><strong><b>收集范围</b></strong
          >：我们可能收集的个人信息包括但不限于您的姓名、联系方式（如手机号码、电子邮箱地址）、地理位置信息、账号登录信息（如登录时间、登录 IP
          地址）、浏览历史、交易记录等。我们仅会在为实现服务目的所必要的范围内收集和使用您的个人信息，不会过度收集。
        </li>
        <li>
          <b><span></span></b><strong><b>使用方式</b></strong
          >：我们会按照法律法规的要求，对收集到的个人信息进行妥善处理和保护。我们可能会对个人信息进行数据分析，以优化服务流程、提升服务质量，但不会将您的个人信息用于与提供服务无关的其他用途。例如，通过分析用户浏览行为优化页面布局，使您更便捷地获取信息。
        </li>
      </ol>
      <h3>
        <strong><b>（二）个人信息的保护措施</b></strong>
      </h3>
      <ol>
        <li>
          <b><span></span></b><strong><b>技术措施</b></strong
          >：我们采用合理的技术手段，如加密技术、访问控制技术等，保护您的个人信息在传输、存储过程中的安全，防止信息被窃取、篡改或泄露。例如，对您的敏感信息（如密码）进行加密存储，确保即使数据被非法获取，也难以被破解。
        </li>
        <li>
          <b><span></span></b><strong><b>管理措施</b></strong
          >：我们建立了严格的内部管理制度，规范员工对个人信息的访问和使用权限。只有经过授权的员工在履行工作职责必要的情况下，才能够访问您的个人信息，且员工需遵守严格的保密义务。若员工违反规定泄露您的个人信息，将受到相应的纪律处分及法律追究。
        </li>
      </ol>
      <p>我们承诺不会未经您的同意，擅自泄露、出售或租赁您的个人信息给任何第三方。</p>
      <h3>
        <strong><b>（三）个人信息的分享</b></strong>
      </h3>
      <p>
        在法律允许的范围内，我们可能会与第三方分享您的个人信息，但前提是该第三方需要遵守严格的隐私保护规定，并采取必要的措施保护您的个人信息安全。例如，我们可能会与为我们提供技术支持、物流配送等服务的合作伙伴分享必要的个人信息，以完成相关服务流程。但我们会通过合同等方式约束第三方，确保其对您的个人信息的处理符合法律法规及本隐私政策的要求。
      </p>
      <h3>
        <strong><b>（四）未成年人信息的保护</b></strong>
      </h3>
      <p>
        我们非常重视对未成年人个人信息的保护。如果您是未满 18
        周岁的未成年人，在使用我们的服务前，应事先获得您的法定监护人的同意，并在监护人的指导下使用我们的服务。我们不会在未获得监护人同意的情况下，主动收集未成年人的个人信息。若我们发现收集到了未成年人的个人信息且未获得监护人同意，我们将及时删除相关信息。
      </p>
      <h2>
        <strong><b>四、免责声明</b></strong>
      </h2>
      <h3>
        <strong><b>（一）服务的中断和故障</b></strong>
      </h3>
      <p>
        在使用我们的服务过程中，由于网络故障、维护升级、第三方服务提供商的原因（如电信运营商网络波动、云服务提供商故障等）等不可预见、不可避免的原因，可能会导致服务中断或故障。对于由此产生的任何直接或间接损失，如您因服务中断无法及时完成交易而造成的经济损失等，我们将不承担任何责任。但我们会尽力在最短时间内恢复服务，并及时通过平台公告等方式通知您服务中断及恢复情况。
      </p>
      <h3>
        <strong><b>（二）用户使用服务的风险</b></strong>
      </h3>
      <p>
        用户在使用我们的服务时应注意网络安全，避免在非安全环境下（如公共网络未采取加密措施、连接到不明来源的 Wi-Fi
        等）使用我们的服务，以免发生信息泄露、资金损失等风险。例如，在不安全的网络环境下登录账号，可能导致账号密码被窃取。用户应自行承担因自身原因（如未妥善保管账号密码、在不安全环境下操作等）使用我们服务所产生的一切风险。
      </p>
      <h2>
        <strong><b>五、协议变更和终止</b></strong>
      </h2>
      <ol>
        <li>
          <b><span></span></b><strong><b>协议变更</b></strong
          >：我们有权根据实际情况、法律法规变化、业务发展需求等，随时对本协议进行修改。修改后的协议将在我们的平台上显著位置进行公布，公布时间即为通知时间。若您在协议修改后继续使用我们的服务，即视为您接受修改后的协议内容。若您不同意修改后的协议，您有权停止使用我们的服务。
        </li>
        <li>
          <b><span></span></b><strong><b>协议终止</b></strong
          >：在以下情况下，我们有权终止本协议及向您提供服务：
          <ul></ul>
        </li>
        <li><span></span>您违反本协议中关于用户义务的相关规定，且在我们通知您后，您未在合理期限内纠正违规行为。例如，您多次发布违法违规内容，经我们警告后仍不改正。</li>
        <li><span></span>您利用我们的服务从事严重违法犯罪活动，我们有权立即终止服务，并依法向相关部门报告。</li>
        <li><span></span>因法律法规调整或政府部门要求，导致我们无法继续向您提供服务。</li>
      </ol>
      <p>
        协议终止后，我们将根据法律法规要求处理您的个人信息，如删除或匿名化处理等。同时，您在协议终止前因使用我们的服务所产生的权利和义务，不因协议终止而免除，仍需按照相关法律法规及本协议约定履行。
      </p>
      <h2>
        <strong><b>六、适用法律和争议解决</b></strong>
      </h2>
      <ol>
        <li>
          <b><span></span></b><strong><b>适用法律</b></strong
          >：本协议的解释、效力及纠纷解决均适用 [具体适用法律名称] 法律。
        </li>
        <li>
          <b><span></span></b><strong><b>争议解决</b></strong
          >：若双方就本协议内容出现争议，应首先通过友好协商解决。协商不成时，任何一方均有权向有管辖权的人民法院提起诉讼。在争议解决期间，除争议事项外，双方应继续履行本协议规定的其他各项义务。
        </li>
      </ol>
      <h2>
        <strong><b>七、其他</b></strong>
      </h2>
      <ol>
        <li><span></span>本协议构成您与我们之间关于使用我们服务的完整协议，取代之前双方就该服务达成的任何口头或书面协议。</li>
        <li><span></span>本协议中各条款的标题仅为方便阅读而设，不影响条款的具体含义及解释。</li>
        <li><span></span>若本协议的任何条款被认定为无效或不可执行，不影响其他条款的有效性和可执行性，其他条款应继续有效并执行。</li>
      </ol>
      <p>&nbsp;</p>
      <p>南京溧水电子研究所有限公司</p>
      <p>2025 年 04 月 16 日</p>
      <p>&nbsp;</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lang: 'zh'
    }
  },
  created() {
    this.lang = localStorage.getItem('lang') || 'zh'
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.agreement_container {
  // background: #F6F7FB;
  background: linear-gradient(180deg, #e8f1fb 0%, #ffffff 100%);
  // background-size: cover;
  width: 100%;
  height: 100vh;
  // overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .agreement-content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 54px);
    overflow: auto;
    padding: 15px;
    font-family: PingFang SC;
  }
  .top-layout {
    display: flex;
    align-items: center;
    position: relative;
    height: 54px;
    .el-icon-arrow-left {
      font-size: 18px;
      font-weight: 600;
      margin-left: 15px;
      cursor: pointer;
      z-index: 10;
    }
    div {
      position: absolute;
      left: 50%;
      width: 100%;
      display: flex;
      z-index: 9;
      justify-content: center;
      align-items: center;
      transform: translate(-50%, 0);
      font-size: 16px;
      font-weight: 800;
      line-height: 28px;
      text-align: center;
      color: #171717;
    }
  }
}
</style>
